import { useState, type FormEvent } from "react";
import { Button, TextField } from "./ui";
import { api, ApiError } from "@/lib/api";
import type { MeDTO } from "@shared/types";

/** Second step of sign-in: a code from the authenticator app, or a recovery code. */
export function MfaStep({ ticket, onDone, onRestart }: { ticket: string; onDone: (me: MeDTO) => void; onRestart: () => void }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onDone(await api.post<MeDTO>("/auth/login/mfa", { ticket, code }));
    } catch (err) {
      if (err instanceof ApiError && err.code === "mfa_expired") onRestart();
      setError(err instanceof ApiError ? err.message : "Could not sign in");
    } finally {
      setBusy(false);
    }
  }
  return (
    <form onSubmit={submit} className="space-y-4">
      <TextField
        label="Code from your authenticator app"
        inputMode="text"
        autoComplete="one-time-code"
        autoFocus
        required
        maxLength={20}
        value={code}
        onChange={(e) => setCode(e.target.value)}
        hint="6 digits, or one of your recovery codes"
        error={error}
      />
      <Button type="submit" size="lg" block loading={busy}>
        Verify
      </Button>
    </form>
  );
}
